import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'

// Styles for this component.
const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 2),
    borderBottom: theme.extras.styles.faintBorder,
  },
}))

const PanelSection = ({ children, ...props }) => {
  const classes = useStyles()

  return (
    <Box className={clsx(classes.root, 'panel-section')}>
      {children}
    </Box>
  )
}

export default PanelSection
